import { render, staticRenderFns } from "./control-cifras-oeb-productividad.vue?vue&type=template&id=305f7a23&scoped=true"
import script from "./control-cifras-oeb-productividad.vue?vue&type=script&lang=js"
export * from "./control-cifras-oeb-productividad.vue?vue&type=script&lang=js"
import style0 from "./control-cifras-oeb-productividad.vue?vue&type=style&index=0&id=305f7a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305f7a23",
  null
  
)

export default component.exports